__webpack_require__.p = "/CU-Assistant/";